import { render, staticRenderFns } from "./NewGame.vue?vue&type=template&id=426824d9&scoped=true"
import script from "./NewGame.vue?vue&type=script&lang=js"
export * from "./NewGame.vue?vue&type=script&lang=js"
import style0 from "./NewGame.vue?vue&type=style&index=0&id=426824d9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426824d9",
  null
  
)

export default component.exports